var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m12.262 2.076 1.431 1.558-.078.029.012.01-.217.075c-.877.3-2.409 1.215-3.53 2.347C8.77 7.217 7.9 8.734 7.9 10.677c-.001 2.448 1.151 4.305 2.874 5.564 1.734 1.267 4.046 1.925 6.318 1.925 2.562 0 4.448-.761 5.564-1.456.38-1.255 1.32-1.754 2-1.88l.036-.023c.116-.07.483-.392.883-.964.39-.558.79-1.322 1-2.246.207-.914.157-1.874-.023-2.71-.18-.84-.482-1.518-.744-1.88l-.145-.08s.016-.514-.056-1.03c-5.504-3.74-11.19-4.106-13.345-3.821zm9.95 5.392c.117-.063.522-.295.955-.78.868.125 1.721.422 1.721.422-1.576-1.032-3.73-1.641-6.117-1.625 0 0 .912 1.405 3.443 1.983zM2 16.004C2 10.094 6.043 5.18 11.41 3.899l-.128.079c-.678.42-1.415.965-1.985 1.535-1.223 1.235-2.22 2.95-2.22 5.162 0 2.743 1.305 4.835 3.212 6.228 1.896 1.386 4.385 2.082 6.802 2.082 2.27 0 4.069-.562 5.33-1.203l-.019.072c.2 3.04 4.219 4.415 7.597 3.614C27.403 26.352 22.436 30 16.47 30c-7.992 0-14.47-6.333-14.47-13.996zm24.241-.758a1.354 1.354 0 0 0-.476-.318 6.57 6.57 0 0 0 .485-.613c.438-.629.889-1.49 1.127-2.536.24-1.058.178-2.142-.02-3.067a7.82 7.82 0 0 0-.221-.814c1.406 1.105 2.472 2.592 2.378 4.63-.14 3.068-1.992 4.274-3.178 4.475.57-.955.095-1.558-.095-1.76z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnt);
export default __webpack_public_path__ + "static/media/ANT.0e1bf7aa59c24b809ad34a51d07b0463.svg";
export { ForwardRef as ReactComponent };